import { SnackbarQueue as MWCSnackbarQueue } from '@rmwc/snackbar';
import "@rmwc/snackbar/styles";

import { queue } from 'utils/snackbar';

const SnackbarQueue = () => <MWCSnackbarQueue messages={queue.messages} />

export default SnackbarQueue;